module.exports = __webpack_public_path__ + "img/simulados-w.0ccf59a8.svg";